{
  "states": {
    "loading": "Memuatkan...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Cerah",
    "Clouds": "Berawan",
    "Rain": "Hujan",
    "Drizzle": "Hujan renyai",
    "Thunderstorm": "Ribut petir",
    "Snow": "Salji",
    "Mist": "Kabus nipis",
    "Smoke": "Asap",
    "Haze": "Jerebu",
    "Dust": "Habuk",
    "Fog": "Kabus",
    "Sand": "Pasir",
    "Ash": "Abu",
    "Squall": "Ribut kencang",
    "Tornado": "Puting beliung"
  },
  "modal": {
    "defaultTitle": "Cuaca",
    "subtitle": "Keadaan semasa",
    "showFahrenheit_aria": "Tunjuk Fahrenheit",
    "showCelsius_aria": "Tunjuk Celsius",
    "switchToCelsius_title": "Tukar ke °C",
    "switchToFahrenheit_title": "Tukar ke °F",
    "feelsLike": "Terasa seperti {{temp}}°{{unit}}",
    "humidityWind": "Kelembapan {{humidity}}% · Angin {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Sekarang",
    "hourlyOffset": "{{hours}}j",
    "hourlyStrip_aria": "Suhu mengikut jam",
    "hourlyLocked": "Ramalan mengikut jam ialah ciri Pro.",
    "statsLocked": "Butiran cuaca ialah ciri Pro.",
    "stats": {
      "sunrise": "Matahari terbit",
      "sunset": "Matahari terbenam",
      "feels": "Terasa",
      "humidity": "Kelembapan",
      "wind": "Angin",
      "rain": "Hujan"
    },
    "rainInches": "{{value}} in",
    "forecastTitle": "Ramalan 5 Hari",
    "forecastLoading": "Memuatkan ramalan…",
    "forecastUnavailable": "Ramalan tidak tersedia",
    "forecastLocked": "Ramalan 5 hari ialah ciri Pro.",
    "forecastRow_aria": "Ramalan lima hari",
    "proHeadline": "Ramalan penuh adalah sebahagian daripada Pro.",
    "proFeatures": "Setiap jam · Keadaan terperinci · Tinjauan 5 hari."
  }
}
